// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3955) return "static/chunks/3955.60706f147c8c8c59.js";
	if (chunkId === 408) return "static/chunks/408.8927f0bc89f68163.js";
	if (chunkId === 7068) return "static/chunks/7068.0cc34b88631cd2ac.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"657":"a15d78d9792eb2b3","5508":"28e43c84e247cdc1","6152":"9bbfb35ca85d0489","8594":"2f8a13a14c145c16"}[chunkId] + ".js";
};